import { createAction } from "@reduxjs/toolkit";
import { SET_IVAND_SCORE, SetIVandActionType } from "./types";

export const setIVandScore = createAction<SetIVandActionType["payload"]>(SET_IVAND_SCORE);
